module.exports = __webpack_public_path__ + "img/appShowcase.08faacca.png";